<template>
  <div class="content">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="backPageFn"></i>{{titleinfo}}
    </div>
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="文章标题">
            <el-input type="text" placeholder="请输入文章标题" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="文章来源">
            <el-input type="text" placeholder="请输入文章来源" v-model="form.source_detail"></el-input>
          </el-form-item>
          <el-form-item label="封面图">
              <uploadImg @getChildValue="getChildValue" imgNumber="1" page="articleCreate"
                         :picSrc="form.pic"></uploadImg>
          </el-form-item>
          <el-form-item label="正文内容" class="mb-40"> 
            <quill-editor
                    class="quill-editor alleditorHeight"
                    v-model="form.content"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"
            >
              <div id="toolbar" slot="toolbar"> 
                <button class="ql-bold" title="加粗">Bold</button>
                <button class="ql-italic" title="斜体">Italic</button>
                <button class="ql-underline" title="下划线">underline</button>
                <button class="ql-strike" title="删除线">strike</button>
                <button class="ql-blockquote" title="引用"></button>
                <button class="ql-code-block" title="代码"></button>
                <button class="ql-header" value="1" title="标题1"></button>
                <button class="ql-header" value="2" title="标题2"></button> 
                <button class="ql-list" value="ordered" title="有序列表"></button>
                <button class="ql-list" value="bullet" title="无序列表"></button> 
                <select class="ql-header" title="段落格式">
                  <option selected>段落</option>
                  <option value="1">标题1</option>
                  <option value="2">标题2</option>
                  <option value="3">标题3</option>
                  <option value="4">标题4</option>
                  <option value="5">标题5</option>
                  <option value="6">标题6</option>
                </select>
                <select class="ql-size" title="字体大小">
                  <option value="small">小</option>
                  <option selected>常规</option>
                  <option value="large">大</option>
                  <option value="huge">特大</option>
                </select>
                <select class="ql-color" value="color" title="字体颜色"></select>
                <select class="ql-background" value="background" title="背景颜色"></select>
                <select class="ql-align" value="align" title="对齐"></select>
                <button class="ql-clean" title="还原"></button>
                <button class="ql-image" title="插入图片"></button>
                <button class="ql-video" title="插入视频"></button>
                <button class="ql-undo" title="撤销" @click="undo"></button>
                <button class="ql-redo" title="重做" @click="redo"></button>
              </div>
            </quill-editor>
          </el-form-item>

          <el-form-item>
            <div v-if="optionInfo.type!=='add'">
              <el-button @click="backPageFn" size="small">取 消</el-button>
              <!--pageType 0 不能修改任何字段 1 -->
              <!--state 1 已经上架 其他未上架-->
              <el-button type="primary" @click="saveArticleFn(0)" size="small">保存</el-button>
              <el-button type="primary" @click="saveArticleFn(1)" size="small">保存并发布</el-button>
            </div>
            <div v-else>
              <el-button @click="backPageFn" size="small">取 消</el-button>
              <el-button type="primary" @click="saveArticleFn(0)" size="small">保存</el-button>
              <el-button type="primary" @click="saveArticleFn(1)" size="small">保存并发布</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="preview_wrap">
        <div class="phone-ios">
          <div class="phone-body">
            <div class="phone-header">
              <img src="/static/img/phone-header.png"/>
              <h4>{{form.title}}</h4>
            </div>
            <div class="phone-body-article">
              <h4 class="phone-title">{{form.title}}</h4>
              <div class="phone-meta">
                <span>2019-06-23 来源：{{form.source_detail}}</span>
                <span>投诉</span>
              </div>
              <div class="phone-content" v-html="form.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";
  import uploadImg from "@/components/dialog/uploadImg.vue";
  import * as Quill from 'quill';
  import {quillEditor} from "vue-quill-editor";
  import { handlers, pasteImage } from "@/assets/js/quill-config";
  import Video from "@/assets/js/quill-video";
  import api from '@/api.js'
  Quill.register(Video, true);

  export default {
    name: "articleCreate",
    components: {
      quillEditor,
      uploadImg
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      }
    },
    data() {
      return {
        titleinfo:'',
        artitype:'',
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        // titile 	varchar 	必填 	- 	- 	文章标题
        // source_detail 	varchar 	必填 	- 	- 	文章来源
        // pic 	varchar 	必填 	- 	- 	封面图
        // content 	varchar 	必填 	- 	- 	文章内容
        // state 	varchar 	必填 	- 	- 	发布状态(0仅保存、1保存并发布)
        optionInfo: '',
        form: {
          title: "",
          source_detail: '',
          pic: '',
          content: '',
          state: ''
        },
        pageType: 0,
        editorOption: { 
         placeholder: "请输入内容",
          theme: "snow", // or 'bubble'
          history: {
            delay: 2000,
            maxStack: 50,
            userOnly: true
          },
          modules: {
            toolbar: {
              container: '#toolbar',
              handlers
            }
          },
          theme: 'snow'          
        },
        imageUrl: ""
      };
    },
    created() {
      
      if(sessionStorage.getItem("menu1")){
        this.optionInfo= this.$route.params
        this.artitype = this.$route.params.type;
      }else{
        this.optionInfo= this.$route.query
        this.artitype = this.$route.query.type;
      }
      if (this.artitype === 'edit') {
          this.titleinfo = "编辑文章";
          this.InitFn()
        } else {
          this.titleinfo = "添加文章";
        };
      
      
    },
    methods: {
      undo() {
        this.$refs.myQuillEditor.quill.history.undo();
      },
      redo(){
        this.$refs.myQuillEditor.quill.history.redo();
      },
      InitFn() {
        if (this.optionInfo.id) {
          this.axios
              .post('companyadmin/article/detail', {article_id: this.optionInfo.id})
              .then(response => {
                if (response.data.code == 0) {
                  for (let i in this.form) {
                    this.form[i] = response.data.info[i]
                  }
                  this.pageType = response.data.info.type
                } else {
                }
              })
              .catch(response => {
              });
        }
      },
      onSubmit() {
        // console.log("submit!");
      },
      handleAvatarSuccess(res, file) {
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.form.pic = res.path
      },
      beforeAvatarUpload(file) {
        // const isJPG = file.type === "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 10;
        // if (!isJPG) {
        //   this.$message.error("上传头像图片只能是 JPG 格式!");
        // }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        return isLt2M;
      },
      onEditorBlur(quill) {
        // console.log("editor blur!", quill);
      },
      onEditorFocus(quill) {
        // console.log("editor focus!", quill);
      },
      onEditorReady(quill) {
        // console.log("editor ready!", quill);
      },
      backPageFn() {
        this.$confirm('您确定要放弃当前修改，返回上一页吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.go(-1);
        }).catch(() => {
        });
      },
      saveArticleFn(option) {
        if (!this.form.title) {
          this.$message({
            message: '请填写文章标题',
            type: 'warning'
          });
          return
        }
        if (!this.form.source_detail) {
          this.$message({
            message: '请填写文章来源',
            type: 'warning'
          });
          return
        }
        if (!this.form.pic) {
          this.$message({
            message: '请上传封面图',
            type: 'warning'
          });
          return
        }
        if (!this.form.content) {
          this.$message({
            message: '请填写正文内容',
            type: 'warning'
          });
          return
        }
        // companyadmin/article/edit
        let url_ = 'companyadmin/article/add'
        let data_ = this.form
        let message = '保存成功！'
        if (this.optionInfo.id) {
          url_ = 'companyadmin/article/edit'
          data_.article_id = this.optionInfo.id
          message = '编辑成功！'
        } else {
          data_.state = option
        }
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: message,
                });
                this.$router.go(-1);
              } else {
              }
            })
            .catch(response => {
            });
      },
      getChildValue(option) {
        this.form.pic = option
      },
    },
    mounted() {
      let revoke=document.querySelector('.quill-editor .ql-undo') //获取元素
      let redo=document.querySelector('.quill-editor .ql-redo') //获取元素
      let Front=document.createElement('i')  //创建元素
      let Frontredo=document.createElement('i')  //创建元素
      Front.className="iconfont iconchexiao" //新增class属性
      Frontredo.className="iconfont iconredo" //新增class属性
      revoke.appendChild(Front) //追加到元素中
      redo.appendChild(Frontredo) //追加到元素中

      pasteImage(this.editor)
    }
  };
</script>

